/* eslint-disable @fullstory/annotate-react/data-component */
import { isFunction } from 'lodash';
import React from 'react';
import { Column, RowKeyAccessor } from './types';

export function useBodyRows<R>(
  // TODO: Make this generic to the type passed in
  Component: React.ComponentType<{ columns: Column<R>[]; row: R } & any>,
  columns: Column<R>[],
  rows: R[],
  rowKeyAccessor: RowKeyAccessor<R>,
  // TODO: Make this dynamic based on the component passed in
  rowProps: { [key: string]: any } = {},
) {
  return rows.map(row => {
    if (!isFunction(rowKeyAccessor) && row[rowKeyAccessor] == null) {
      console.error(`
        Row key accessor error.
        Row object does not have a property named "${String(
          rowKeyAccessor,
        )}" to be used as the unique ID.
        Each row must contain a unique key.
      `);
    }
    const key = isFunction(rowKeyAccessor) ? rowKeyAccessor(row) : row[rowKeyAccessor];
    return <Component {...rowProps} columns={columns} row={row} key={key} />;
  });
}
